'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
require('../style-222d2b0f.js');
var hr = require('../hr.js');
var span = require('../typography/span.js');
var transparent = require('../button/transparent.js');
var s18 = require('../typography/s18.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n"]);

var ObjectHeader = styled__default.div(_templateObject);

var ArrayFieldGroupItem = function ArrayFieldGroupItem(_ref) {
  var onClickRemoveButton = _ref.onClickRemoveButton,
      removeButtonText = _ref.removeButtonText,
      removable = _ref.removable,
      title = _ref.title,
      children = _ref.children,
      removeBtnId = _ref.removeBtnId,
      key = _ref.key;
  return React__default.createElement(
    "div",
    { key: key },
    React__default.createElement(
      ObjectHeader,
      null,
      React__default.createElement(
        s18.default,
        { margin: "0", lineHeight: "24px" },
        title
      ),
      removable && React__default.createElement(
        transparent.TransparentButton,
        {
          id: removeBtnId,
          type: "button",
          color: settings.COLOR.textBlack,
          hoverColor: settings.COLOR.lightGray,
          weight: "600",
          padding: "0",
          margin: "0",
          onClick: onClickRemoveButton },
        React__default.createElement(icon.Icon, { icon: "close" }),
        React__default.createElement(
          span,
          { margin: "0 0 0 5px", size: "16px", lineHeight: "22px" },
          removeButtonText
        )
      )
    ),
    children,
    React__default.createElement(hr.default, { margin: "30px 0 0 0" })
  );
};

ArrayFieldGroupItem.propTypes = {
  /** text to display above field group */
  title: PropTypes$1.string,
  /** text to display on remove field group button */
  removeButtonText: PropTypes$1.string,
  /** function to execute when click remove field group button */
  onClickRemoveButton: PropTypes$1.func,
  /** status to display remove button */
  removable: PropTypes$1.bool,
  /** remove group button ID */
  removeBtnId: PropTypes$1.string.isRequired
};

ArrayFieldGroupItem.defaultProps = {
  removable: true
};
ArrayFieldGroupItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrayFieldGroupItem",
  "props": {
    "removable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "status to display remove button"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display above field group"
    },
    "removeButtonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display on remove field group button"
    },
    "onClickRemoveButton": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function to execute when click remove field group button"
    },
    "removeBtnId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "remove group button ID"
    }
  }
};

exports.ObjectHeader = ObjectHeader;
exports.default = ArrayFieldGroupItem;
//# sourceMappingURL=item.js.map
